/* sugar:assets/section-as-seen-on.js@2.2.0 */
/*
 * As Seen On: a header placed over the logos thins them in an ellipse around its words
 * (the track's --aso-hole-mask). CSS cannot know how wide the words are, so this measures
 * the header box against the track and hands the ellipse its centre and radii.
 *
 * Sizes come from offsetWidth/offsetHeight and positions are divided by the track's rendered
 * scale, so an entrance animation that scales the strip mid-flight still yields the resting
 * geometry. Every host is read before any is written, and a value is written only when it
 * changes.
 */
(function () {
  if (window.SugarAsoHole) return;
  window.SugarAsoHole = true;

  var hosts = [];
  var queued = false;
  var ro = new ResizeObserver(queue);

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(measure);
  }

  function measure() {
    queued = false;
    hosts = hosts.filter(function (h) {
      if (h.track.isConnected) return true;
      ro.unobserve(h.track);
      ro.unobserve(h.wrap);
      return false;
    });

    var reads = hosts.map(function (h) {
      var tw = h.track.offsetWidth;
      var ww = h.wrap.offsetWidth;
      if (!tw || !ww) return '';
      var t = h.track.getBoundingClientRect();
      var w = h.wrap.getBoundingClientRect();
      var scale = t.width / tw || 1;
      return [
        Math.round((w.left - t.left + w.width / 2) / scale),
        Math.round((w.top - t.top + w.height / 2) / scale),
        Math.round(ww / 2),
        Math.round(h.wrap.offsetHeight * 2.4),
      ].join(',');
    });

    reads.forEach(function (value, i) {
      var h = hosts[i];
      if (value === h.last) return;
      h.last = value;
      var style = h.track.style;
      if (!value) {
        style.removeProperty('--aso-hole-x');
        style.removeProperty('--aso-hole-y');
        style.removeProperty('--aso-hole-rx');
        style.removeProperty('--aso-hole-ry');
        return;
      }
      var v = value.split(',');
      style.setProperty('--aso-hole-x', v[0] + 'px');
      style.setProperty('--aso-hole-y', v[1] + 'px');
      style.setProperty('--aso-hole-rx', v[2] + 'px');
      style.setProperty('--aso-hole-ry', v[3] + 'px');
    });
  }

  function mount(root) {
    var track = root.querySelector('.sugar-as-seen-on__track');
    var wrap = root.querySelector('.sugar-as-seen-on__header-wrapper');
    if (!track || !wrap) return;
    for (var i = 0; i < hosts.length; i++) if (hosts[i].track === track) return;
    hosts.push({ track: track, wrap: wrap, last: null });
    ro.observe(track);
    ro.observe(wrap);
    // An entrance animation settles by transition; measure its resting state.
    root.addEventListener('transitionend', queue);
    queue();
  }

  function scan() {
    document
      .querySelectorAll('.sugar-as-seen-on[data-aso-pos-d$="_overlay"], .sugar-as-seen-on[data-aso-pos-m$="_overlay"]')
      .forEach(mount);
  }

  scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:block:select', e => { const root = e.target.closest && e.target.closest('[data-aso-quotes]'); if (root && root._asoEditorSelect) root._asoEditorSelect(e.target); });
})();
(function () {
  if (window.SugarAsoQuotes) return;
  window.SugarAsoQuotes = true;
  // A paged slider clones logos at its ends, so a logo is matched by its block id: a click on a
  // clone selects its original, and the highlight is drawn on every copy. The highlight class is
  // is-selected because Splide keeps its own is-active on whichever slide leads the view.
  function mount(root) {
    if (root.dataset.asoReady) return;
    const quotes = Array.from(root.querySelectorAll('[data-aso-quote]'));
    const items = Array.from(root.querySelectorAll('.sugar-as-seen-on-logo:not(.splide__slide--clone)')).filter(item => quotes.some(quote => quote.dataset.asoLogo === item.dataset._sf));
    if (!items.length) return;
    let active = 0, timer;
    const delay = Number(root.dataset.asoInterval) * 1000;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    function select(index, follow) {
      active = (index + items.length) % items.length;
      const id = items[active].dataset._sf;
      root.querySelectorAll('.sugar-as-seen-on-logo').forEach(logo => {
        const current = logo.dataset._sf === id;
        logo.classList.toggle('is-selected', current);
        const button = logo.querySelector('[data-aso-select]');
        if (button) button.setAttribute('aria-pressed', String(current));
      });
      quotes.forEach(quote => {
        const current = quote.dataset.asoLogo === id;
        quote.setAttribute('aria-hidden', String(!current));
        quote.classList.toggle('is-active', current);
      });
      // A rotation that reaches a logo the slider has paged out of view brings it back in.
      const slider = root.querySelector('[data-aso-splide]');
      const splide = slider && slider._asoSplide;
      if (follow && splide && !items[active].classList.contains('is-visible')) {
        const slide = splide.Components.Slides.get(true).find(s => s.slide === items[active]);
        if (slide) splide.go(slide.index);
      }
    }
    function stop() { clearInterval(timer); }
    function start() { stop(); if (delay && !reduced.matches && items.length > 1) timer = setInterval(() => { if (root.isConnected && !document.hidden) select(active + 1, true); else if (!root.isConnected) stop(); }, delay); }
    root.addEventListener('click', e => {
      const button = e.target.closest('[data-aso-select]');
      const logo = button && button.closest('.sugar-as-seen-on-logo');
      if (!logo || !root.contains(logo)) return;
      const i = items.findIndex(item => item.dataset._sf === logo.dataset._sf);
      if (i >= 0) { select(i); start(); }
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    root._asoEditorSelect = target => { const i = items.findIndex(item => item.contains(target)); if (i >= 0) select(i); stop(); };
    select(0); root.dataset.asoReady = 'true'; start();
  }
  function scan() { document.querySelectorAll('[data-aso-quotes]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:block:select', e => { const root = e.target.closest && e.target.closest('[data-aso-quotes]'); if (root && root._asoEditorSelect) root._asoEditorSelect(e.target); });
})();
/*
 * As Seen On, paged slider (Marquee: Off, paged slider): mounts Splide on [data-aso-splide] with
 * the options the section drew its row with, and hands the arrows and dots to the shared slider
 * chrome. Every logo is a slide (the block renders no wrapper of its own).
 *
 * A whole phone count is perPage; a fraction (1.8) is a fixed slide width of that share of the
 * track with one slide per move, so the next logo peeks in, and omitEnd drops the end positions
 * a fraction would repeat. A looping row draws a dot per logo, one that stops at its ends a dot
 * per page (the section draws the same dots before this runs). Tablets (750-1199px) show no more logos than fit at about 190px each,
 * measured on the row the way the stylesheet's pre-mount row is (base.css, data-sw-row).
 * Every row is measured before any slider mounts. If Splide never arrives the row scrolls by
 * finger instead.
 */
(function () {
  if (window.SugarAsoSlider) return;
  window.SugarAsoSlider = true;

  function num(value, fallback) {
    var n = parseFloat(value);
    return isNaN(n) ? fallback : n;
  }

  function tabletPerPage(width, desktop) {
    if (!width) return desktop;
    return Math.min(desktop, width < 400 ? 1 : width < 610 ? 2 : width < 820 ? 3 : width < 1030 ? 4 : desktop);
  }

  function phone(per, gap) {
    if (per === Math.floor(per)) return { perPage: per, fixedWidth: 0, gap: gap + 'px' };
    return { perPage: 1, fixedWidth: 'calc((100% + ' + gap + 'px) / ' + per + ' - ' + gap + 'px)', gap: gap + 'px' };
  }

  function teardown(el) {
    if (el._scChrome) {
      try { el._scChrome.detach(); } catch (e) {}
      el._scChrome = null;
    }
    if (el._asoSplide) {
      try { el._asoSplide.destroy(true); } catch (e) {}
      el._asoSplide = null;
    }
    if (el._asoResize) {
      window.removeEventListener('resize', el._asoResize);
      el._asoResize = null;
    }
  }

  function mount(el, rowWidth) {
    var list = el.querySelector('.splide__list');
    if (!list || el._asoSplide) return;
    var count = 0;
    Array.prototype.forEach.call(list.children, function (child) {
      if (!child.classList.contains('sugar-as-seen-on-logo')) return;
      child.classList.add('splide__slide');
      count++;
    });
    if (!count) return;

    var d = el.dataset;
    var perD = Math.max(1, Math.round(num(d.perPage, 4)));
    // A desktop logo width keeps every slot that wide above the phone, one logo per move
    var widthD = Math.max(0, num(d.logoWidth, 0));
    var perM = Math.max(1, num(d.perPageM, 2));
    var gapD = num(d.gap, 40);
    var gapM = num(d.gapM, 24);
    var tablet = { perPage: widthD ? 1 : tabletPerPage(rowWidth, perD) };
    var instance;
    try {
      instance = new Splide(el, {
        type: d.loop === 'true' ? 'loop' : 'slide',
        perPage: widthD ? 1 : perD,
        perMove: 1,
        fixedWidth: widthD ? widthD + 'px' : 0,
        gap: gapD + 'px',
        omitEnd: true,
        speed: 450,
        arrows: false,
        pagination: false,
        i18n: {
          prev: 'Previous slide',
          next: 'Next slide',
          first: 'Go to first slide',
          last: 'Go to last slide',
          slideX: 'Go to slide %s',
          pageX: 'Go to page %s'
        },
        // Splide applies the narrowest matching breakpoint, so 749 wins on phones.
        breakpoints: { 1199: tablet, 749: phone(perM, gapM) }
      });
      instance.mount();
    } catch (e) {
      fallback(el);
      return;
    }
    el._asoSplide = instance;

    var host = el.closest('[data-sc-host]');
    if (window.SugarSliderChrome && host) {
      el._scChrome = window.SugarSliderChrome.attach(instance, host, { dotMode: d.loop === 'true' ? 'slide' : 'page' });
    }

    // A tablet that turns, or a window resized within 750-1199px, counts its logos again.
    var row = el.closest('[data-sw-row]');
    if (row && !widthD) {
      var timer;
      el._asoResize = function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var next = tabletPerPage(row.getBoundingClientRect().width, perD);
          if (next === tablet.perPage) return;
          tablet.perPage = next;
          if (window.innerWidth >= 750 && window.innerWidth < 1200) instance.Components.Media.set({ perPage: next });
        }, 150);
      };
      window.addEventListener('resize', el._asoResize);
    }
  }

  function fallback(el) {
    var host = el.closest('[data-sc-host]');
    if (host) host.setAttribute('data-aso-static', '');
  }

  function whenSplide(done) {
    if (typeof Splide !== 'undefined') return done();
    if (window.SugarVendor && window.SugarVendor.loadSplide) {
      window.SugarVendor.loadSplide().then(done, done);
      return;
    }
    setTimeout(function () { whenSplide(done); }, 120);
  }

  function scan(scope) {
    var els = Array.prototype.filter.call((scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-aso-splide]'), function (el) {
      return !el._asoSplide;
    });
    if (!els.length) return;
    whenSplide(function () {
      if (typeof Splide === 'undefined') {
        els.forEach(fallback);
        return;
      }
      var widths = els.map(function (el) {
        var row = el.closest('[data-sw-row]');
        return row ? row.getBoundingClientRect().width : 0;
      });
      els.forEach(function (el, i) {
        if (el.isConnected) mount(el, widths[i]);
      });
    });
  }

  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelectorAll) e.target.querySelectorAll('[data-aso-splide]').forEach(teardown);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target && e.target.closest && e.target.closest('.splide__slide');
    var el = slide && slide.closest('[data-aso-splide]');
    var splide = el && el._asoSplide;
    if (!splide) return;
    var match = splide.Components.Slides.get(true).filter(function (s) { return s.slide === slide; })[0];
    if (match) splide.go(match.index);
  });
})();
